import PDFFileIcon from 'components/Icons/PDFFileIcon'
import PropTypes from 'prop-types'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { openFreshPartFile } from 'store/actions'

/**
 * @param {object} args
 * @param {number} args.partId
 * @param {function} [args.t]
 * @param {number} args.isModifiedBluePrint
 * @param {'originalBlueprint'|'modifiedBlueprint'} args.fileType
 */
export const BlueprintOpener = ({ partId, t, isModifiedBluePrint, fileType = 'originalBlueprint' }) => {
	const dispatch = useDispatch()
	const url = useSelector(state =>
		(/** @type {StoreState} */(state)).CloudStorage.partsFiles?.parts?.find(p => parseInt(p.id) === partId)?.fileLinks?.[fileType]
	)
	const tooltipMessage = isModifiedBluePrint ? t('open_modified_pdf', { ns: 'naming' }) : t('open_pdf', { ns: 'naming' })

	return (
		<div>
			{url ?
				<div className="cursor" onClick={() => dispatch(openFreshPartFile(partId, fileType, url))}>
					<PDFFileIcon invertedColor={isModifiedBluePrint} tooltipMessage={tooltipMessage} />
				</div>
				:
				<div>
				</div>
			}
		</div>
	)
}

BlueprintOpener.propTypes = {
	partId: PropTypes.number,
	t: PropTypes.func,
	isModifiedBluePrint: PropTypes.bool,
	fileType: PropTypes.oneOf(['originalBlueprint', 'modifiedBlueprint']),
}

export default withTranslation()(BlueprintOpener)
